import PlayerSlot from "./PitchSlot";

export default function PitchRow({
  slots,
  lineup,
  onSlotClick,
  onRowReorder,
  className,
  style,
}) {
  return (
    <div className={`pitch-row ${className}`} style={style}>
      {slots.map((slot) => {
        const player = lineup[slot];

        return (
          <div
            key={slot}
            draggable={!!player}
            onDragStart={() =>
              player && onRowReorder("START", player.id)
            }
            onDragOver={(e) => e.preventDefault()}
            onDrop={() =>
              player && onRowReorder("DROP", player.id)
            }
          >
            <PlayerSlot
              player={player}
              onClick={() => onSlotClick(slot)}
            />
          </div>
        );
      })}
    </div>
  );
}
